import { Component, Vue, Watch } from 'vue-property-decorator'
import { getMessageReview, setMessageReviewUserColorByMessageReviewId, getMessageReviewByUserId, setMessageReviewUserByMessageReviewIdList, getMessageReviewCcList } from '@/api/message'
import { MessageModule } from '@/store/modules/message'
import { UserModule } from '@/store/modules/user'
import realTimeSokcet from '@/utils/socket.io'
import { delNullProperty } from '@/utils/index'
import {formatDate} from "@/utils/timeFilter";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";

const approvalTypesList = [
  { key: '修改论文服务类型'},
  { key: '合作伙伴'},
  { key: '回款'},
  { key: '开票'},
  { key: '换项目' },
  { key: '申请退项' },
  { key: '订单' },
  { key: '转案' },
  { key: '返佣' },
  { key: '退回线索' },
  { key: '退款' },
  { key: '市场费用' },
  { key: '撞单' },
  { key: '合同'},
  { key: '转化客户跟进'},
  { key: '转化客户调入公海'},
  { key: '转销回款'},
  { key: '转销开票'},
  { key: '修改Laser证书'},
]

const nodeStatusList = [
  { key: '全部' },
  { key: '待审批', value: 0 },
  { key: '已通过', value: 1 },
  { key: '已驳回', value: 2 },
]
const statusList = [
  { key: '全部' },
  { key: '审批中', value: 0 },
  { key: '已通过', value: 1 },
  { key: '未通过', value: 2 },
  { key: '已撤回', value: 3 },
]
@Component({
  components:{
    MoreUsersFilter
  }
})
export default class MessageApproval extends Vue {
  // ------ 变量 ------
  tableData = []
  page = 1
  limit = 20
  total = 0
  approvalSubjectScreening = 'first' // 审批场景的筛选值
  ApprovalScenariosScreening = -1 // 审批主体的筛选值
  nodeStatus = null  //审批状态筛选值
  checkedTable = []
  tableKey = Math.random() //我审批的
  tableKey1 = Math.random() //我提交的
  tableKey2 = Math.random() //抄送我的
  socket = null
  status = null
  filter_types = ''
  filter_mainBody = ''
  filter_createdUserId = ''
  createdAt: Date[] | null = null
  updatedAt: Date[] | null = null
  mainBodyStatus = ''
  tableLoading = false
  approvalSubjectScreeningList = [
    { val: 'first', name: '我审批的' },
    { val: 'second', name: '我提交的' },
    { val: 'third', name: '抄送我的' }
  ]

  mainBodyStatusList = [
    { val: '0', name: '暂无' },
    { val: '1', name: '新增' },
    { val: '2', name: '修改' }
  ]

  approvalTypesList = approvalTypesList
  nodeStatusList = nodeStatusList
  statusList = statusList
  batchApprovalBtn = false  //批量审批连点
  timer = null
  // isReadonly = false

  get userId() {
    return UserModule.userId
  }


  get messageReviewNum() {
    return MessageModule.reviewNum
  }

  get messageReviewUserNum() {
    return MessageModule.reviewUserNum
  }

  // created
  created() {
    this.getTableData()
    if (this.userId) this.initSocket()
    const approvalType = this.$route.query.approvalType
    if (approvalType === '0') {
      this.approvalSubjectScreening = 'first'
    } else if (approvalType === '2') {
      this.approvalSubjectScreening = 'third'
    }
  }

  handleClick(tab, event) {
    // console.log(tab, event);
  }

  handleStatus(val){
    this.filter_mainBody = ''
    this.mainBodyStatus = ''
    this.filter_types = ''
    this.filter_createdUserId = ''
    this.createdAt = []
    this.nodeStatus = null
    this.status = null
    this.updatedAt = []

    this.getTableData()
  }
  async getTableData() {
    this.tableLoading = true

    MessageModule.getMessageCount()
    const obj = {
      page: this.page,
      limit: this.limit,
      status: this.status,
      types: this.filter_types,
      mainBody: this.filter_mainBody,
      createdUserId: this.filter_createdUserId,
      createdAt: this.changeTime(this.createdAt as Date[]),
      updatedAt: this.changeTime(this.updatedAt as Date[]),
      mainBodyStatus:this.mainBodyStatus
    }
    if (this.status === -1) {
      delete obj.status
    }
    if (this.status === 1) {
      delete obj.createdUserId
    }
    if (this.approvalSubjectScreening === 'second') {  //我提交的
      const data: any = await getMessageReview(delNullProperty(obj))
      this.total = data.allNum
      this.tableData = data.messageReviewList
      // this.$nextTick(() => {
      //   (this.$refs.multipleTable2 as HTMLFormElement).bodyWrapper.scrollTop = 0;
      // });
    }
    if (this.approvalSubjectScreening === 'first') { //我审批的
      if(this.nodeStatus != null) obj['thisNodeStatus'] = this.nodeStatus
      const data: any = await getMessageReviewByUserId(delNullProperty(obj))
      this.total = data.allNum
      this.tableData = data.messageReviewList
      // this.$nextTick(() => {
      //   (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
      // });
    }
    if (this.approvalSubjectScreening === 'third') {
      const data = await getMessageReviewCcList(delNullProperty(obj)) as unknown as { messageReviewCcList: []; allNum: number }
      this.tableData = data.messageReviewCcList
      this.total = data.allNum
      // this.$nextTick(() => {
      //   (this.$refs.multipleTable3 as HTMLFormElement).bodyWrapper.scrollTop = 0;
      // });
    }
    this.tableLoading = false
    // this.isReadonly = false
  }

  async setTagReview(id) {
    await setMessageReviewUserColorByMessageReviewId({ messageReviewId: id})
    this.getTableData()
  }

  setApprovalScenariosScreening(num: number) {
    this.ApprovalScenariosScreening = num
    this.status = this.ApprovalScenariosScreening
    this.page = 1
    this.getTableData()
  }
  // setApprovalSubjectScreening(num: number) {
  //   this.approvalSubjectScreening = num
  //   this.checkedTable = []
  //   this.page = 1
  //   this.getTableData()
  // }
  nodeScreening(num: number) {
    this.nodeStatus = num
    this.page = 1
    this.getTableData()
  }

  handleSizeChange(val: number) {
    this.limit = val
    this.getTableData()
  }
  handleCurrentChange(val: number) {
    this.page = val
    this.getTableData()
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  async batchReview() {
    // TODO 批量通过审批
    this.batchApprovalBtn = true
    await setMessageReviewUserByMessageReviewIdList({
      messageReviewIdList: this.checkedTable.map(item => item.id),
      status: 1
    }).then(() => {
      this.$message.success('批量设置通过审批')
      this.checkedTable = []
      this.getTableData()
      this.batchApprovalBtn = false
    }).catch(() => {
      this.batchApprovalBtn = false
    })
  }

  handleSelectionChange(val: any) {
    this.checkedTable = val
  }

  selectable(row) {
    return row.nodeStatus === 0 && row.status === 0 && row.select
  }

  /*
  @params row 被点击的改行的数据
  */
  clickLook(row,types) {
    /*
    * types 指的是 审批抄送还是提交类型*/
    // 1-我提交的查看, 2-我审批的查看
    let type = '1'
    if(this.approvalSubjectScreening === 'first') {
      type = '2'
    }
    switch (row.types) {
      case '退回线索':
        this.openPage('/transfromCustomerCancleBackClue?id=' + row.id + '&status=' + row.nodeStatus+ '&types=' + types)
        break;
      case '订单':
        if(row.isDissertation == "1"){  //论文订单
          this.openPage('/paperOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        }else{  //普通订单
          this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        }
        break;
      case '换项目': // 订单换项目
        if(row.isDissertation == "1"){  //论文订单
          this.openPage('/paperOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        }else{  //普通订单
          this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        }
        break;
      case '修改论文服务类型':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
        // 订单laser证书
      case '修改Laser证书':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转案':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '申请退项':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '回款':
        this.openPage('/approvalBackMoneu?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '返佣':
        this.openPage('/commissionInfos?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '开票':
        this.openPage('/makeInvoice?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '退款':
        this.openPage('/refund?refundId=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '合作伙伴':
        this.openPage('/cooperativePartner?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '市场费用':
        this.openPage('/marketCost?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '撞单':
        this.openPage('/repeatOrder?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '合同':
        this.openPage('/contract?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types+ '&financeContractTypes=' + row.financeContractTypes) // type 0-审批，1-查看
        break;
      case '转化客户跟进':
        this.openPage('/followRecord?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转化客户调入公海':
        this.openPage('/pubCustomerApproval?approval_id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转销回款':
        this.openPage('/resaleApproval?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转销开票':
        this.openPage('/resaleInvoiceRecord?id=' + row.id + '&status=' + row.status + '&type=' + type+ '&types=' + types) // type 0-审批，1-查看
        break;
      default:
        break;
    }
  }

  clickApproval(row,types) {
    // types 提交还是抄送还是审批类型
    switch (row.types) {
      case '退回线索':
        this.openPage('/pageBackClue?id=' + row.id + '&status=' + row.nodeStatus+ '&types=' + types)
        break;
      case '订单':
        if(row.isDissertation == "1"){  //论文订单
          this.openPage('/paperOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0 + '&types=' + types) // type 0-审批，1-查看
        }else{  //普通订单
          this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        }
        break;
      case '换项目': // 订单换项目
        // this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0) // type 0-审批，1-查看
        if(row.isDissertation == "1"){  //论文订单
          this.openPage('/paperOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        }else{  //普通订单
          this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        }
        break;
      case '修改论文服务类型':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '修改Laser证书':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转案':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '申请退项':
        this.openPage('/reviewOrder?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '回款':
        this.openPage('/approvalBackMoneu?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '返佣':
        this.openPage('/commissionInfos?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '开票':
        this.openPage('/makeInvoice/?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '退款':
        this.openPage('/refund?refundId=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '合作伙伴':
        this.openPage('/cooperativePartner?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '市场费用':
        this.openPage('/marketCost?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '撞单':
        this.openPage('/repeatOrder?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '合同':
        this.openPage('/contract?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types + '&financeContractTypes=' + row.financeContractTypes ) // type 0-审批，1-查看
        break;
      case '转化客户跟进':
        this.openPage('/followRecord/?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转化客户调入公海':
        this.openPage('/pubCustomerApproval/?approval_id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转销回款':
        this.openPage('/resaleApproval/?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      case '转销开票':
        this.openPage('/resaleInvoiceRecord/?id=' + row.id + '&status=' + row.nodeStatus + '&type=' + 0+ '&types=' + types) // type 0-审批，1-查看
        break;
      default:
        break;
    }
  }
  openPage(url: string) {
    const win = window.open(window.location.origin + this.$route.matched[0].path + url, '_blank')
    const time = setInterval(() => {
      if (win.closed) {
        this.getTableData()
        clearInterval(time)
      }
    }, 500)
  }

  changeCreatid(e) {
    this.filter_createdUserId = e.id
    this.pageChange(1)
  }


  // watch: approvalSubjectScreening
  @Watch('approvalSubjectScreening')
  handleWatchApprovalSubjectScreening(val: number) {
    this.page = 1
    this.getTableData()
  }

  initSocket() {
    const time = setInterval(() => {
      if (Vue.prototype.$socket.on) {
        realTimeSokcet(this.userId, 'Review', this.getTableData)
        clearInterval(time)
      }
    }, 100)
  }

  @Watch('userId')
  handleWatchUserid() {
    this.initSocket()
  }


  // 时间区间过滤器
  changeTime(val: Date[]): string {
    if (val == null) return ''
    let time = ''
    val.forEach((item: any) => {
      time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
    })
    time = time.slice(0, time.length - 1)
    return time
  }
}
